import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Typography, Container } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';


const NotFound: FC = () => {
    const navigate = useNavigate();

    const goToMainPage = (): void => {
        navigate('/');
    };

    return (
        <Container maxWidth="md">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    textAlign: 'center',
                    py: 8,
                }}
            >
                <ErrorOutlineIcon
                    sx={{
                        fontSize: 120,
                        color: 'error.main',
                        mb: 3,
                        opacity: 0.9,
                    }}
                />

                <Typography
                    variant="h1"
                    sx={{
                        fontSize: { xs: '4rem', sm: '6rem', md: '8rem' },
                        fontWeight: 700,
                        color: 'text.primary',
                        mb: 2,
                        lineHeight: 1,
                    }}
                >
                    404
                </Typography>

                <Typography
                    variant="h4"
                    sx={{
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                        fontWeight: 500,
                        color: 'text.secondary',
                        mb: 1,
                    }}
                >
                    Page Not Found
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontSize: '1.125rem',
                        color: 'text.secondary',
                        mb: 4,
                        maxWidth: 500,
                    }}
                >
                    The page you are looking for doesn't exist or has been moved.
                </Typography>

                <Button
                    variant="contained"
                    size="large"
                    startIcon={<HomeIcon />}
                    onClick={goToMainPage}
                    sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: '1rem',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: 2,
                        boxShadow: 3,
                        '&:hover': {
                            boxShadow: 6,
                            transform: 'translateY(-2px)',
                        },
                        transition: 'all 0.3s ease',
                    }}
                >
                    Go to Main Page
                </Button>
            </Box>
        </Container>
    );
};

export default NotFound;